import { logoCumm, logoHino, logoInter, logoMerc, motorFront, motorBack,
    imgAutoBus, imgCodFa, imgDiagrama, imgMant, imgManu } from "../../img/ImgBarrel"


// MUI
import {Breadcrumbs, Button, Grid, Stack } from "@mui/material";
import {Fragment, useState} from "react";
import {PageWorkingComponent} from "../../Global/pageWorking";
import {CardItemComponent} from "./CardItem";
import {AddNewManualDialog} from "./newManual";
import {ShowAllManualComponent} from "./ShowAllManual";

const MARCAS = [
    {
        name: "Cummins",
        img: logoCumm.default,
        tool: "Última actualización 20/12/2023",
        type_moto: 1,

    },
    {
        name: "HINO",
        img: logoHino.default,
        tool: "Última actualización 20/12/2023",
        type_moto: 1,

    },
    {
        name: "INTERNATIONAL",
        img: logoInter.default,
        tool: "Última actualización 20/12/2023",
        type_moto: 1,

    },
    {
        name: "Mercedes-Benz",
        img: logoMerc.default,
        tool: "Última actualización 20/12/2023",
        type_moto: 2,

    },
]

const MOTOR = [
    {
        name: "Delantero",
        img: motorFront.default
    },
    {
        name: "Trasero",
        img: motorBack.default
    }
]

const UNIDAD = {
    "Mercedes-Benz":[
        {name:"904", img: imgAutoBus.default},
        {name:"906", img: imgAutoBus.default},
        {name:"904", img: imgAutoBus.default},
        {name:"926", img: imgAutoBus.default},
        {name:"296 AdBlue", img: imgAutoBus.default},
        {name:"924 AdBlue", img: imgAutoBus.default},
    ],
    "Cummins": [
        {name:"ISB", img: imgAutoBus.default},
    ],
    "INTERNATIONAL": [
        {name:"DT-466", img: imgAutoBus.default},
        {name:"MWM EURO IV", img: imgAutoBus.default},
        {name:"MWM EURO III", img: imgAutoBus.default},
    ],
    "HINO": [
        {name:"HINO", img: imgAutoBus.default},
    ],
}

const OPTIONS = [
    {
        name: "Código de falla",
        img: imgCodFa.default
    },
    {
        name: "Diagrama",
        img: imgDiagrama.default
    },
    {
        name: "Mantenimiento",
        img: imgMant.default
    },
    {
        name: "Manuales",
        img: imgManu.default
    },
]

const NAVIGATION_MENU = [
    {name: "Todo"}
]
export function ManualComponent(){

    const [ historialMenu, setHistorialMenu ] = useState(NAVIGATION_MENU);
    const [ unitSelected, setUnitSelected ] = useState(0);

    const [ showNewManual, setShowNewManual ] = useState(false);
    const [ showAllManual, setShowAllManual ] = useState(false);

    const handlingClickNavigation = (dataOption) =>{
        if(dataOption?.type_moto !== 2){
            setUnitSelected(unitSelected+1 );
        }

        setHistorialMenu((oldData)=>
            [
                ...oldData,
                {
                    ...dataOption
                }
            ]
        )

    }

    const handlingClickNameNavigation = (nameNavagation) =>{

        if(historialMenu[historialMenu.length-1].name === nameNavagation.name){
            return;
        }

        if(nameNavagation.name === "Todo"){
            setUnitSelected(0);
            setHistorialMenu(NAVIGATION_MENU);
        }else if(MARCAS.some(things=> things.name === nameNavagation.name) && nameNavagation.type_moto){
            let index = historialMenu.findIndex(things => things.name === nameNavagation.name);
            let new_historial = historialMenu.slice(0, index+1);
            let value = nameNavagation.type_moto === 2 ? 0:index;
            setUnitSelected(value);
            setHistorialMenu(new_historial);
        }else if( !!historialMenu[1] && !!historialMenu[2] ){
            let new_historial = [...historialMenu];
            if(nameNavagation.name === "Trasero" || nameNavagation.name === "Delantero"){
                new_historial.pop();
            }

            new_historial.pop();
            let value = nameNavagation.name === "Trasero" || nameNavagation.name === "Delantero" ? 1:2
            setUnitSelected(value);
            setHistorialMenu(new_historial);
        }
    }

    return(
            <Grid container justifyContent="center" spacing={3}>

                <Grid item xs={12}>
                    <Stack>
                        <Breadcrumbs separator=">" aria-label="breadcrumb">
                            {
                                historialMenu.map((things, index)=> <Button variant="text" onClick={()=>handlingClickNameNavigation(things)} key={`nav-${index}`}>{things.name}</Button> )
                            }
                        </Breadcrumbs>
                    </Stack>
                </Grid>

                <Grid item xs={12} container direction="row"
                    justifyContent="flex-end" alignItems="center">
                    <Button variant="contained" color="info" onClick={()=>setShowAllManual(!showAllManual)}>
                        {showAllManual ? "Cerrar":"Mostrar todos los manuales"}
                    </Button>
                    <Button onClick={()=>setShowNewManual(!showNewManual)} variant="contained" color="success">Nuevo manual</Button>
                </Grid>

                {
                    historialMenu.length === 1 &&
                    <Fragment>
                        {
                            MARCAS.map((marca, index)=>(

                                <Grid item xs={2} key={`manual-${marca.name}-${index}`}>
                                    <CardItemComponent
                                        thingsData={marca}
                                        handlingClickItem={handlingClickNavigation}
                                    />
                                </Grid>
                            ))
                        }
                    </Fragment>
                }
                {
                    historialMenu.length > 1 && unitSelected === 0  ?
                        <Fragment>
                            {
                                MOTOR.map((motor, index)=>(
                                    <Grid item xs={2} key={`manual-${motor.name}-${index}`}>
                                        <CardItemComponent
                                            thingsData={motor}
                                            handlingClickItem={handlingClickNavigation}
                                        />
                                    </Grid>
                                ))
                            }
                        </Fragment>:
                        null
                }
                {
                    unitSelected === 1  ?
                        <Fragment>
                            {
                                UNIDAD[historialMenu[1].name].map((unit, index)=>(
                                    <Grid item xs={2} key={`manual-${unit.name}-${index}`}>
                                        <CardItemComponent
                                            thingsData={unit}
                                            handlingClickItem={handlingClickNavigation}
                                        />
                                    </Grid>
                                ))
                            }
                        </Fragment>:
                        null
                }
                {
                    unitSelected === 2 &&
                    <Fragment>
                        {
                            OPTIONS.map((option,index)=>(
                                <Grid item xs={2} key={`manual-${option.name}-${index}`}>
                                        <CardItemComponent
                                            thingsData={option}
                                            handlingClickItem={handlingClickNavigation}
                                        />
                                    </Grid>
                            ))
                        }
                    </Fragment>
                }
                {
                    unitSelected === 3 &&
                    <PageWorkingComponent/>
                }
                {
                    showNewManual &&
                    <AddNewManualDialog
                        open={showNewManual}
                        handlingCloseDialog={()=>setShowNewManual(!showNewManual)}
                    />
                }

                {
                    showAllManual &&
                    <Grid item xs={12}>
                        <ShowAllManualComponent
                            open={showAllManual}
                            handlingCloseDialog={()=>setShowAllManual(!showAllManual)}
                        />
                    </Grid>
                }

            </Grid>
    );
}